export enum CashBoxStatus {
  IN_PROGRESS = "IN_PROGRESS",
  SENT = "SENT",
  CONFIRM = "CONFIRM",
  REPORT_SUBMITTED = "REPORT_SUBMITTED",
  TO_FIX = "TO_FIX",
  CLOSE = "CLOSE"
}